import { useState } from 'react'
import { Link as LinkIcon } from 'lucide-react'

function faviconUrl(domain: string): string {
  return `https://www.google.com/s2/favicons?sz=64&domain_url=${encodeURIComponent(domain)}`
}

/** Hostname a favicon can be looked up by, or '' when the URL is unparseable. */
export function faviconDomain(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, '')
  } catch {
    return ''
  }
}

/**
 * A site's favicon, falling back to a link glyph. Fills its container; `size`
 * only scales the fallback.
 *
 * Only for hosts with no known brand: the lookup service answers a host it has
 * never crawled with a generic 16px globe rather than an error, so neither
 * guard below can catch a miss. Per-tenant hostnames (`{workspace}.slack.com`)
 * miss that way for almost every tenant.
 */
export function FaviconImage({ domain, size }: { domain: string; size: number }) {
  const [errored, setErrored] = useState(false)

  if (errored) {
    return (
      <div className="bg-element-hover flex h-full w-full items-center justify-center">
        <LinkIcon size={Math.round(size * 0.55)} className="text-foreground-placeholder" />
      </div>
    )
  }

  return (
    <img
      src={faviconUrl(domain)}
      alt=""
      className="h-full w-full object-contain"
      onError={() => setErrored(true)}
      onLoad={(e) => {
        if (e.currentTarget.naturalWidth <= 1) setErrored(true)
      }}
    />
  )
}
